import tagTester from './_tagTester.js';

export default tagTester('Object');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/_hasObjectTag.js
// module id = 1303
// module chunks = 9